import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-booking-confirmation-preview',
  templateUrl: './booking-confirmation-preview.component.html',
  styleUrls: ['./booking-confirmation-preview.component.css']
})
export class BookingConfirmationPreviewComponent implements OnInit {

  htmlString!: string;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = false;
  }

  ngOnInit(): void {
    let confirmationId = Number(this.route.snapshot.paramMap.get("confirmationId"));
    if (confirmationId) {
      this.httpService.getBookingConfirmationHtmlString(confirmationId).subscribe(res => {
        this.htmlString = res;
      });
    }

    let finalConfirmationId = Number(this.route.snapshot.paramMap.get("finalConfirmationId"));
    if (finalConfirmationId) {
      this.httpService.getBookingFinalConfirmationHtmlString(finalConfirmationId).subscribe(res => {
        this.htmlString = res;
      });
    }
  }

}
